// Safely turn any axios error response into a human-readable string.
// FastAPI validation errors come back as { detail: [{ msg, loc, ... }] }
// which crashes React when rendered directly.
export function errorMessage(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const first = d[0];
    if (first && typeof first === "object" && first.msg) return String(first.msg);
    return d.map((x) => (typeof x === "string" ? x : x?.msg || "")).filter(Boolean).join(", ") || fallback;
  }
  if (d && typeof d === "object" && d.msg) return String(d.msg);
  if (err?.message) return String(err.message);
  return fallback;
}
